import { GET_ANALYTICS_FAILED, GET_ANALYTICS_REQUEST, GET_ANALYTICS_RESET, GET_ANALYTICS_SUCCESS, SET_DASHBOARD_REVIEW } from "../types"

const initialState = {
	isLoading: false,
	data: {},
	selectedReview: {},
}

// eslint-disable-next-line
export default function (state = initialState, action) {
	switch (action.type) {
		case GET_ANALYTICS_REQUEST:
			return {
				...state,
				isLoading: true,
			}
		case GET_ANALYTICS_SUCCESS:
			return {
				...state,
				isLoading: false,
				data: action.payload,
			}
		case GET_ANALYTICS_FAILED:
			return {
				...state,
				isLoading: false,
				error: action.payload,
			}
		case GET_ANALYTICS_RESET:
			return {
				...state,
				data: {},
			}
		case SET_DASHBOARD_REVIEW:
			return {
				...state,
				selectedReview: action.payload,
			}
		default:
			return state
	}
}
